var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "absolute w-full bottom-0 inset-x-0 pointer-events-none",
      attrs: { "data-test": "tab-overflow" }
    },
    [
      _c("div", {
        staticClass: "h-4 mx-4",
        style: _vm.style,
        attrs: { "data-test": "tab-overflow--shadow" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }